import { RootState } from "../../store";

export const selectTest = (state: RootState) => state.test;